module.exports = __webpack_public_path__ + "img/rihua1.b6df43a9.jpg";